import React from 'react'

const React_Assignment_7 = () => {
  return (
    <div>
      <h1>Assignment 7</h1>
    </div>
  )
}

export default React_Assignment_7
